import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from "react-helmet-async";


// Step 1: Disable browser's automatic scroll restoration
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

// Step 2: Get root element
const rootElement = document.getElementById("root");

// Step 3: Hydrate if prerendered HTML exists (react-snap output)
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
    </React.StrictMode>
  );
} else {
  // Normal render (dev mode or first load without prerender)
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
    <HelmetProvider>
      <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}

// Step 4: Web vitals (optional performance logging)
reportWebVitals();
